import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import { Store } from '@ngrx/store';
import { FormControl, Validators } from '@angular/forms';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';

import { FollowUpWindowComponent } from './followUpWindow.component';
import { FollowUpCalendarModalComponent } from './followUpCalendarModal.component';

import { FollowUpService, CommonService, UnsoldDescriptionService, TelecallerTempAssignService } from '../../../services/index';
import { FollowUpModel } from '../../../model/index';
// import { SkuService } from '../../services/index';
// import { SkuModel } from '../../model/index';

import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';

@Component({
    selector: 'follow-up',
    templateUrl: './followUp.component.html'
})
export class FollowUpComponent implements OnInit {
    itemList: any;
    filterst: any;
    columns = [];
    appliedFutureStIds: string[] = [];
    isLoadMask: Promise<any>;
    filterData = {
        "search_data": "",
        "reference": "",
        "promo_name": "",
        "promo_type": "",
        "adv_from_date": null,
        "adv_to_date": null,
        "employee_id": ""
    };
    loadingIndicator: boolean = true;
    suppressPaging: boolean = false;
    scrollTimeout: any;
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'cfs.date',
        orderDir: 'asc'
    };
    totTask: number = 0;
    comTask: number = 0;
    tot_task: number = 0;
    new_task: number = 0;
    col_filterList: any;
    followUpStatusList: any;
    unsoldFeedBackList: any[];
    soldFeedBackList: any[];
    followUpList: FollowUpModel[];
    referenceCtrl: FormControl;
    statusCtrl: FormControl;
    districtCtrl: FormControl;
    unsoldCtrl: FormControl;
    soldCtrl: FormControl;
    employeeCtrl: FormControl;
    private searchTermsEmployee = new Subject<string>();
    districtLists$ = [];
    districtlist = [];
    followUpListdt: any;
    followUpMonthListdt: any = [];
    hasOwnRecord: boolean = true;
    userid: any = "";
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('optionTemplate') optionTemplate: TemplateRef<any>;
    @ViewChild('willingTemplate') willingTemplate: TemplateRef<any>;
    @ViewChild('nameTplTemplate') nameTplTemplate: TemplateRef<any>;
    @ViewChild('fromTplTemplate') fromTplTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    @ViewChild('clientAutoComp') clientAutoComp;
    @ViewChild('statusAutoComp') statusAutoComp;
    @ViewChild('districtAutoComp') districtAutoComp;

    filteredReference: Observable<any[]>;
    filteredFollowupStatus: Observable<any[]>;
    filteredDistrict: Observable<any[]>;
    filteredBranch: Observable<any[]>;
    filteredEmployee: Observable<any[]>;

    bsModalRef: BsModalRef;
    branchList: any[] = [];
    branchCtrl: FormControl;
    employeeList: any[] = [];
    followupNameList: Array<any>;
    currentYear = new Date().getFullYear();
    yearList: any[] = [];
    monthList: any[] = [];
    followUpUserList: any;
    userType: string;
    currentUserId: any;

    unsoldDescriptionList: any[] = [];
    tempAssignInfo: any = null;
    tempCount: number = 0;

    constructor(public store: Store<fromRootStore.State>, private followUpService: FollowUpService, private modalService: BsModalService, private commonService: CommonService, private unsoldDescriptionService: UnsoldDescriptionService, private telecallerTempAssignService: TelecallerTempAssignService) {
        function hasValidRef(input: FormControl) {
            let testTypeID = input.value, retVal = null;
            if (testTypeID == "") {
                retVal = { inValidRef: true };
            }
            if (testTypeID && typeof testTypeID === 'string') {
                retVal = { inValidRef: true };
            }
            return retVal;
        }

        function hasValidUnSold(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Willing" && ledgerID != "Not-Willing"
                && ledgerID != "No-Answer") {
                retVal = { inValidUnsold: true };
            }

            return retVal;
        }
        this.unsoldCtrl = new FormControl('', [
            Validators.required,
            hasValidUnSold.bind(this)
        ]);
        // this.unsoldCtrl = new FormControl();
        this.unsoldFeedBackList = ['Willing', 'Not-Willing', 'No-Answer'];
        function hasValidSold(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Satisfied" && ledgerID != "Not-Satisfied"
                && ledgerID != "No-Answer") {
                retVal = { inValidSold: true };
            }

            return retVal;
        }
        this.soldCtrl = new FormControl('', [
            Validators.required,
            hasValidSold.bind(this)
        ]);
        //this.soldCtrl = new FormControl();
        this.soldFeedBackList = ['Satisfied', 'Not-Satisfied', 'No-Answer'];
        this.referenceCtrl = new FormControl('', [
            Validators.required,
            hasValidRef.bind(this)
        ]);
        this.filteredReference = this.referenceCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterItems(name) : this.itemList.slice());

        this.statusCtrl = new FormControl();
        this.filteredFollowupStatus = this.statusCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterStatus(name) : this.followUpStatusList.slice());

        this.branchCtrl = new FormControl();
        this.filteredBranch = this.branchCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBranch(name) : this.branchList.slice());

        function hasValidBranch(input: FormControl) {
            let branchID = input.value, retVal = null;
            if (branchID && typeof branchID === "string") {
                retVal = { inValidBranch: true };
            }
            return retVal;
        }
        this.branchCtrl = new FormControl('', [
            Validators.required,
            hasValidBranch.bind(this)
        ]);

        function hasValidEmployee(input: FormControl) {
            let empID = input.value, retVal = null;
            if (empID && !isNaN(empID) && empID > 0) {
                return null; // Valid employee ID
            } else if (empID && (isNaN(empID) || empID <= 0)) {
                retVal = { inValidEmployee: true };
            }
            return retVal;
        }
        this.employeeCtrl = new FormControl('', [
            Validators.required,
            hasValidEmployee.bind(this)
        ]);

        let that = this;
        this.filteredEmployee = this.searchTermsEmployee
            .debounceTime(300)
            .distinctUntilChanged()
            .switchMap(term => term
                ? this.commonService.getEmployeeList(term, 'challan')
                : Observable.of<any[]>([]))
            .catch(error => {
                console.log(error);
                return Observable.of<any[]>([]);
            });
        this.filteredEmployee.subscribe(($e) => {
            that.employeeList = $e;
        });

    }

    ngOnInit(): void {
        this.filterst = this['params']['tabParams'];
        let that = this;

        const trackCol = { name: 'Track', prop: 'no_of_follow', sortable: false, width: 60, minWidth: 60, maxWidth: 60 };
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 55, minWidth: 55, maxWidth: 55, sortable: false, cellTemplate: this.snoTemplate, toggle: true },
            { name: 'Entry Date', prop: 'date', width: 100, minWidth: 100, maxWidth: 100, toggle: true },
            { name: 'Followup Date', prop: 'fol_date', width: 200, minWidth: 200, maxWidth: 200, toggle: true },
            { name: 'Client ID', prop: 'client_no', width: 130, minWidth: 130, maxWidth: 130 },
            { name: 'Name', prop: 'client_name', sortable: false, width: 180, minWidth: 180, maxWidth: 180, cellTemplate: this.nameTplTemplate },
            { name: 'Reference', prop: 'reference_name', sortable: false, width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Last Followup Date', prop: 'last_followup_date', sortable: false, width: 280, minWidth: 280, maxWidth: 280 },
            { name: 'Status', prop: 'status_name', sortable: false, width: 100, minWidth: 100, maxWidth: 100 },
            { name: 'Followup Type', prop: 'fol_type', sortable: false, width: 130, minWidth: 130, maxWidth: 130 },
            { name: 'Next Followup Date', prop: 'fol_date', sortable: false, width: 280, minWidth: 280, maxWidth: 280 },
            { name: 'Last Followup Employee Name', prop: 'employee_name', sortable: false, width: 280, minWidth: 280, maxWidth: 280 },
            // { name: 'Phone No', prop: 'mobile', sortable: false, width: 100, minWidth: 100, maxWidth: 100 },
            trackCol,
            { name: 'Willing', prop: 'willing', sortable: false, width: 80, minWidth: 80, maxWidth: 80, cellTemplate: this.willingTemplate },
            { name: 'Options', prop: 'sno', width: 230, minWidth: 230, maxWidth: 230, sortable: false, cellTemplate: this.optionTemplate }
        ];

        // Add Advance Paid Date column for HV and SOA tabs
        if (this.filterst === 'HV' || this.filterst === 'SOA') {
            this.columns.splice(7, 0, { name: 'Advance Paid Date', prop: 'advance_paid_date_formatted', sortable: false, width: 160, minWidth: 160, maxWidth: 160 });
        }

        // Add Promo Name column for CAMP PROMO followup type
        if (this.filterst === 'CAMP PROMO') {
            this.columns.splice(7, 0, { name: 'Promo Name', prop: 'promo_name', sortable: false, width: 120, minWidth: 120, maxWidth: 120 });
        }

        // Add Promo Type column for Promo Unsold followup type
        if (this.filterst === 'Promo Unsold') {
            this.columns.splice(7, 0, { name: 'Promo Type', prop: 'promo_type', sortable: false, width: 120, minWidth: 120, maxWidth: 120 });
        }

        // Add Employee Name column for Unsold followup type
        // if (this.filterst === 'Unsold' || this.filterst === 'Dummy Sales' || this.filterst === 'Sales') {
        //     this.columns.splice(-1, 0, { name: 'Last Followup Employee Name', prop: 'employee_name', sortable: false, width: 280, minWidth: 280, maxWidth: 280 });
        // }

        // Add Unsold Remarks and Unsold Reason Details columns for Unsold tab
        if (this.filterst === 'Unsold' || this.filterst === 'Unsold OCT' || this.filterst === 'Promo Unsold') {
            this.columns.splice(-1, 0, { name: 'Unsold Remarks', prop: 'unsold_description_name', sortable: false, width: 250, minWidth: 250, maxWidth: 250 });
            this.columns.splice(-1, 0, { name: 'Unsold Reason Details', prop: 'unsold_reason_details', sortable: false, width: 250, minWidth: 250, maxWidth: 250 });
        }
        this.col_filterList = ['1 Month Calls', '6 Month Calls', '1 Year Calls', '1.6 Year Calls', '2 Year Calls', '2.6 Year Calls',];
        if (this.filterst === 'NotWillingNow') {
            this.yearList = this.getYearList();
            this.monthList = [{ name: 'ALL', id: '' }, { name: 'JAN', id: 0 }, { name: 'FEB', id: 1 }, { name: 'MAR', id: 2 }, { name: 'APR', id: 3 }, { name: 'MAY', id: 4 }, { name: 'JUN', id: 5 }, { name: 'JUL', id: 6 }, { name: 'AUG', id: 7 }, { name: 'SEP', id: 8 }, { name: 'OCT', id: 9 }, { name: 'NOV', id: 10 }, { name: 'DEC', id: 11 }];
        }
        if (this.filterst === 'Unsold' || this.filterst === 'Unsold OCT' || this.filterst === 'Promo Unsold') {
            this.unsoldDescriptionService.getActiveUnsoldDescriptionList().then((res: any) => {
                if (res && res.data) {
                    this.unsoldDescriptionList = res.data;
                }
            });
        }

        this.pageCallback({ offset: 0 });
        // this.branchCtrl = new FormControl();
        //TO GET BRANCH LIST
        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                //this.store.dispatch(new commonActions.LoadAllBrand());
                //this.brandList$ = res;
                return;
            }
            that.branchList = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' });
        });

        // Initialize employee list for Unsold followup
        if (this.filterst === 'Unsold') {
            this.employeeList = [];
        }
        this.store.select(fromCommonStore.getAllReference).subscribe((res: any) => {
            if (_.isEmpty(res)) {
                //this.store.dispatch(new commonActions.LoadAllReference());
                //this.brandList$ = res;
                return;
            }
            this.itemList = res;
            that.referenceCtrl.setValue(that.filterData['reference']);
        });

        // TO GET USER TYPE
        this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            if (auth['islogin']) {
                this.currentUserId = auth['userid'];
                if (auth['usertype'] == 'User') {
                    this.filterData['branch'] = auth['branch_id'];
                    this.branchCtrl.disable();
                }
                this.userid = auth['userid'];
                this.telecallerTempAssignService.getActiveTempAssign({ user_id: auth['userid'] }).then(res => {
                    if (res && res.success && res.data) {
                        that.tempAssignInfo = res.data;
                        const nameColIdx = that.columns.findIndex(c => c.prop === 'client_name');
                        if (nameColIdx !== -1 && !that.columns.find(c => c.name === 'From')) {
                            that.columns.splice(nameColIdx + 1, 0, { name: 'From', prop: 'is_temp', sortable: false, width: 150, minWidth: 150, maxWidth: 150, cellTemplate: that.fromTplTemplate });
                            that.columns = [...that.columns];
                        }
                    }
                });
            }
        });

        this.store.select(fromCommonStore.getAllFollowUpStatus).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                return;
            }
            if (this['params']['tabParams'] == 'HV' && this.userid == 105) {
                that.followUpStatusList = _.filter(res.data, { 'team_id': 1, 'hv_1': 'Yes' });
                that.followupNameList = _.filter(res.data, { 'is_working_followup': 'Yes' });
            } else if (this['params']['tabParams'] == 'HV' && this.userid == 108) {
                that.followUpStatusList = _.filter(res.data, { 'team_id': 1, 'hv_2': 'Yes' });
                that.followupNameList = _.filter(res.data, { 'is_working_followup': 'Yes' });
            } else if (this['params']['tabParams'] == 'SOA') {
                that.followUpStatusList = _.filter(res.data, { 'team_id': 2 });
                that.followupNameList = _.filter(res.data, { 'is_working_followup': 'Yes' });
            } else if (this['params']['tabParams'] == 'Trial Not Willing') {
                that.followUpStatusList = _.filter(res.data, function(item) {
                    return item['trial_not_willing'] === 'Yes';
                });
                that.followupNameList = _.filter(res.data, { 'is_working_followup': 'Yes' });
            } else if (this['params']['tabParams'] == 'Bilateral Willing Client') {
                that.followUpStatusList = _.filter(res.data, function(item) {
                    return item['bilateral_willing_client'] === 'Yes';
                });
                that.followupNameList = _.filter(res.data, { 'is_working_followup': 'Yes' });
            } else if (this['params']['tabParams'] == 'Unsold OCT') {
                that.followUpStatusList = _.filter(res.data, { 'team_id': 5 });
                that.followupNameList = _.filter(res.data, { 'is_working_followup': 'Yes' });
            } else if (this['params']['tabParams'] == 'Store Followup' && this.userid == 174) {
                that.followUpStatusList = _.filter(res.data, function(item) {
                    return item['Store Followup'] === 'Yes' || item['fol_id'] === 1;
                });
                that.followupNameList = _.filter(res.data, function(item) {
                    return item['Store Followup'] === 'Yes' || item['fol_id'] === 1;
                });
            } else if (this['params']['tabParams'] == 'Store Followup') {
                that.followUpStatusList = _.filter(res.data, { 'Store Followup': 'Yes' });
                that.followupNameList = _.filter(res.data, { 'Store Followup': 'Yes' });
            } else if (this['params']['tabParams'] == 'CAMP PROMO') {
                that.followUpStatusList = _.filter(res.data, { 'CAMP PROMO': 'Yes' });
                that.followupNameList = _.filter(res.data, { 'CAMP PROMO': 'Yes' });
            } else if (this['params']['tabParams'] == 'Store Service Followup') {
                that.followUpStatusList = _.filter(res.data, { 'store_service_followup': 'Yes' });
                that.followupNameList = _.filter(res.data, { 'store_service_followup': 'Yes' });
            } else {
                that.followUpStatusList = _.filter(res.data, { 'team_id': 10 });
                that.followupNameList = _.filter(res.data, { 'is_working_followup': 'Yes' });
            }

        });

        function hasValidDistrict(input: FormControl) {
            let branchID = input.value, retVal = null;
            if (branchID && typeof branchID === "string") {
                let item = _.find(this.districtlist, { 'districts_name': branchID });
                if (item == undefined) {
                    retVal = { inValidDistrict: true };
                }
                //retVal = { inValidDistrict: true };
            }
            return retVal;
        }
        this.districtCtrl = new FormControl('', [
            Validators.required,
            hasValidDistrict.bind(this)
        ]);

        //this.districtCtrl = new FormControl();
        this.filteredDistrict = this.districtCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterDistrict(name) : this.districtlist.slice());
        this.getDistricts();

        /*       this.filterData['random_no'] = this.getRandomInt(1, 500); */


    }

    // To get list of years for Not Willing Now Followup
    getYearList() {
        this.filterData['year'] = this.currentYear;
        this.filterData['month'] = '';
        this.handleYearChange(this.currentYear);
        var minYear = this.currentYear - 9;
        var years = [{ name: 'ALL', id: '' }, { name: this.currentYear, id: this.currentYear }];

        for (var year = this.currentYear - 1; year >= minYear; year--) {
            years.push({ name: year, id: year });
        }
        return years;
    };

    // To handle year change for Not Willing Now Followup
    handleYearChange(value) {
        if (value) {
            if (this.filterData['month'] !== '') {
                this.filterData['from_date'] = new Date(value, this.filterData['month'], 1);
                this.filterData['to_date'] = new Date(value, this.filterData['month'] + 1, 0);
            } else {
                this.filterData['from_date'] = new Date(value, 0, 1);
                this.filterData['to_date'] = new Date(value, 11, 31);
            }
        } else {
            this.filterData['month'] = '';
            this.filterData['from_date'] = null;
            this.filterData['to_date'] = null;
        }
    }

    // To handle month change for Not Willing Now Followup
    handleMonthChange(value) {
        if (value !== '') {
            this.filterData['from_date'] = new Date(this.filterData['year'], value, 1);
            this.filterData['to_date'] = new Date(this.filterData['year'], value + 1, 0);
        } else {
            this.filterData['from_date'] = new Date(this.filterData['year'], 0, 1);
            this.filterData['to_date'] = new Date(this.filterData['year'], 11, 31);
        }
    }
    getDistricts() {
        let that = this;
        this.commonService
            .getDistrictList()
            .then(function (res: any) {
                if (res.success) {
                    that.districtlist = res.data;
                }
            });
    }
    displayDistrict(districtname) {
        let that = this;
        return districtname;
    }
    filterDistrict(name: string) {
        name = _.escapeRegExp(name);
        return this.districtlist.filter(item => (new RegExp(name, 'gi').test(item.districts_name)));
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getFollowUpList();
    }
    /**
    * TO CHANGE SPECIFIC ROW COLOR
    */
    getRowClass(row) {
        if (row.important == 'true') {
            return {
                'important-follow-up': row.important == 'true'
            };
        } else if (row.prev_day_entry == 'true') {
            return {
                'follow-up-prev-day-rec': row.prev_day_entry == 'true'
            };
        }
    }
    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        this.page.offset = pageInfo.offset;
        if (!this.suppressPaging) {
            this.getFollowUpList();
        }
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100);
    }
    onOpenedFilter(): void {
        setTimeout(function () {
            $('#filterSearch').focus();
        }, 100);

    }

    clearFilter(): void {
        this.appliedFutureStIds = [];
        this.filterData = {
            "search_data": "",
            "reference": "",
            "promo_name": "",
            "promo_type": "",
            "adv_from_date": null,
            "adv_to_date": null,
            "employee_id": ""
        };
        if (this.filterst === 'NotWillingNow') {
            this.filterData['year'] = this.currentYear;
            this.filterData['from_date'] = new Date(this.currentYear, 0, 1);
            this.filterData['to_date'] = new Date(this.currentYear, 11, 31);
        }

        // Reset form controls
        if (this.filterst === 'Unsold') {
            this.employeeCtrl.setValue('');
        }

        this.applyFilter();
    }

    applyFilter(): void {
        //this.filterExpand = false;
        this.page.offset = 0;
        this.filterPanel.close();
        this.getFollowUpList();
    }
    /*displayFn(branchID: any) {
        if (this.branchList != undefined) {
            if (branchID && this.branchList.length > 0) {
                let fitem = _.find(this.branchList, { 'branch_id': branchID });
                //this.branchList['company_name'] = fitem.branchList; //ANOTHER FIELD
                return fitem['branch_name'];
            }
        }
        return '';

    }*/


    getFollowUpList(): void {
        let branch_ids = "";
        if (!_.isEmpty(this.filterData["branches"])) {
            branch_ids = _.join(this.filterData["branches"], ',');
        }
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            branch_id: branch_ids,
            applied_st_ids: this.appliedFutureStIds ? this.appliedFutureStIds.join(',') : '',
            search_data: this.filterData['search_data'],
            reference: this.filterData['reference'],
            important: this.filterData['important'],
            willing: this.filterData['willing'],
            follow_up_willing: this.filterData['follow_up_willing'] || '',
            notsatisfied: this.filterData['notsatisfied'],
            col_status: this.filterData['col_status'],
            from_page: this['params']['tabParams'],
            new_calls: this.filterData['new_calls'],
            folupstatus: this.filterData['fol_id'],
            districts: this.filterData['districts'],
            unsold_feedback: this.filterData['unsold_feedback'],
            sold_feedback: this.filterData['sold_feedback'],
            fol_status: this.filterData['fol_status'],
            promo_name: this.filterData['promo_name'],
            promo_type: this.filterData['promo_type'],
            employee_id: this.filterData['employee_id'],
            unsold_description_id: this.filterData['unsold_description_id'],
        };

        if (_.isDate(this.filterData['from_date'])) {
            params['from_date'] = moment(this.filterData['from_date']).format('YYYY-MM-DD');
        }
        if (_.isDate(this.filterData['to_date'])) {
            params['to_date'] = moment(this.filterData['to_date']).format('YYYY-MM-DD');
        }
        if (_.isDate(this.filterData['walk_from'])) {
            params['walk_from'] = moment(this.filterData['walk_from']).format('YYYY-MM-DD');
        }
        if (_.isDate(this.filterData['walk_to'])) {
            params['walk_to'] = moment(this.filterData['walk_to']).format('YYYY-MM-DD');
        }
        if (_.isDate(this.filterData['adv_from_date'])) {
            params['adv_from_date'] = moment(this.filterData['adv_from_date']).format('YYYY-MM-DD');
        }
        if (_.isDate(this.filterData['adv_to_date'])) {
            params['adv_to_date'] = moment(this.filterData['adv_to_date']).format('YYYY-MM-DD');
        }
        let that = this;
        this.isLoadMask = this.followUpService
            .getFollowUpList(params)
            .then(function (res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.followUpList = res.data;
                if (that.appliedFutureStIds && that.appliedFutureStIds.length > 0 && that.followUpList) {
                    that.followUpList.forEach((item: any) => {
                        const sid = (item.st_id || '').toString();
                        if (that.appliedFutureStIds.indexOf(sid) !== -1) {
                            item.is_applied_future = 1;
                        }
                    });
                }
                that.followUpListdt = res.listdt;
                that.followUpMonthListdt = res.monthListdt && res.monthListdt.length ? res.monthListdt : [];
                that.hasOwnRecord = res.hasOwnRecord;
                that.followUpUserList = res.userList;
                that.userType = res.userType;

                that.totTask = res.totCnt;
                that.comTask = 0;
                if (res.data.length > 0) {
                    that.comTask = res.data[0]['com_task'];
                }
                that.tempCount = res.tempCount || 0;
                // if (res.data.length > 0) {
                //     that.comTask = res.data[0]['com_task'];
                //     that.tot_task = res.data[0]['tot_task'];
                //     if(that.tot_task==null || that.tot_task == undefined){
                //         that.tot_task = 0;
                //     }
                //     that.new_task = res.data[0]['new_task'];
                //     if(that.new_task==null || that.new_task == undefined){
                //         that.new_task = 0;
                //     }
                //     that.totTask = that.tot_task + that.new_task;
                // }
            });
    }

    filterItems(name: string) {
        name = _.escapeRegExp(name);
        return this.itemList.filter(item => (new RegExp(name, 'gi').test(item.client_code) || new RegExp(name, 'gi').test(item.name)));
    }
    filterStatus(name: string) {
        name = _.escapeRegExp(name);
        return this.followUpStatusList.filter(item => (new RegExp(name, 'gi').test(item.name)));
    }

    filterBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.branchList.filter(item => (new RegExp(name, 'gi').test(item.branch)));
    }

    searchEmployee(query: string) {
        this.searchTermsEmployee.next(query);
    }

    filterEmployee(name: string) {
        name = _.escapeRegExp(name);
        return this.employeeList.filter(item => (new RegExp(name, 'gi').test(item.fullname || item.empname)));
    }

    displayBranchFn(branchID: number) {
        if (branchID && this.branchList.length > 0) {
            let branchObj = _.find(this.branchList, { 'branch_id': branchID });
            return branchObj['branch_name'];
        }
        return '';
    }

    displayEmployeeFn(empID: number) {
        if (empID && this.employeeList && this.employeeList.length > 0) {
            // First try to find by empid, then by userid for compatibility
            let empObj = _.find(this.employeeList, { 'empid': empID }) || _.find(this.employeeList, { 'userid': empID });
            if (empObj) {
                return empObj['empname'] || empObj['fullname'];
            }
        }
        return '';
    }

    displayRef(item_id: number) {
        if (item_id && this.itemList.length > 0) {
            let fitem = _.find(this.itemList, { 'ref_id': item_id });
            return fitem['name'];
        }
        return '';
    }
    displayStatus(fol_id: number) {
        if (fol_id && this.followUpStatusList.length > 0) {
            let fitem = _.find(this.followUpStatusList, { 'fol_id': fol_id });
            return fitem['name'];
        }
        return '';
    }

    displayFollowup(fol_id: number) {
        if (fol_id && this.followupNameList.length > 0) {
            let fitem = _.find(this.followupNameList, { 'fol_id': fol_id });
            return fitem['name'];
        }
        return '';
    }

    changeFollowUp(row: object, mode: string): void {
        let that = this;
        row['mode'] = mode;

        this.bsModalRef = this.modalService.show(FollowUpWindowComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg theme-purple compWidth-90'
        });

        this.bsModalRef.content.followUpTeam = this['params']['tabParams'];
        this.bsModalRef.content.followUpDet = Object.assign({}, row);
        this.bsModalRef.content.followUpListGridUpdateEvent.subscribe(($e) => {
            if (row && row['st_id']) {
                const stIdStr = (row['st_id']).toString();
                that.appliedFutureStIds = that.appliedFutureStIds.filter(id => id !== stIdStr);
            }
            that.getFollowUpList();

        });
    }

    getFollowUpListForExcel(): void {
        let branch_ids = "";
        if (!_.isEmpty(this.filterData["branches"])) {
            branch_ids = _.join(this.filterData["branches"], ',');
        }
        let params = {
            start: '0',
            limit: '4000',
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            branch_id: branch_ids,
            applied_st_ids: this.appliedFutureStIds ? this.appliedFutureStIds.join(',') : '',
            search_data: this.filterData['search_data'],
            reference: this.filterData['reference'],
            important: this.filterData['important'],
            willing: this.filterData['willing'],
            follow_up_willing: this.filterData['follow_up_willing'] || '',
            notsatisfied: this.filterData['notsatisfied'],
            col_status: this.filterData['col_status'],
            from_page: this['params']['tabParams'],
            new_calls: this.filterData['new_calls'],
            folupstatus: this.filterData['fol_id'],
            districts: this.filterData['districts'],
            unsold_feedback: this.filterData['unsold_feedback'],
            sold_feedback: this.filterData['sold_feedback'],
            fol_status: this.filterData['fol_status'],
            promo_name: this.filterData['promo_name'],
            promo_type: this.filterData['promo_type'],
            employee_id: this.filterData['employee_id'],
            unsold_description_id: this.filterData['unsold_description_id']
        };

        if (_.isDate(this.filterData['from_date'])) {
            params['from_date'] = moment(this.filterData['from_date']).format('YYYY-MM-DD');
        }
        if (_.isDate(this.filterData['to_date'])) {
            params['to_date'] = moment(this.filterData['to_date']).format('YYYY-MM-DD');
        }
        if (_.isDate(this.filterData['walk_from'])) {
            params['walk_from'] = moment(this.filterData['walk_from']).format('YYYY-MM-DD');
        }
        if (_.isDate(this.filterData['walk_to'])) {
            params['walk_to'] = moment(this.filterData['walk_to']).format('YYYY-MM-DD');
        }
        if (_.isDate(this.filterData['adv_from_date'])) {
            params['adv_from_date'] = moment(this.filterData['adv_from_date']).format('YYYY-MM-DD');
        }
        if (_.isDate(this.filterData['adv_to_date'])) {
            params['adv_to_date'] = moment(this.filterData['adv_to_date']).format('YYYY-MM-DD');
        }
        let that = this;
        this.isLoadMask = this.followUpService
            .getFollowUpList(params)
            .then(function (res: any) {
                const columns = that.columns.filter(obj => !obj.cellTemplate);
                // Add suffix to title if it doesn't already contain 'followup'
                let title = that['params']['tabParams'];
                if (title.toLowerCase().indexOf('followup') === -1) {
                    title = title + ' Followup';
                }

                let data = {
                    columns: JSON.stringify(columns),
                    data: JSON.stringify(res.data),
                    title: title
                };

                that.isLoadMask = that.commonService
                    .printing(data)
                    .then(function (res: any) {
                        if (res['_body']) {
                            var headers = res['headers']["_headers"],
                                ctype = headers.get('content-type')[0],
                                cdispos = headers.get('content-disposition')[0],
                                filename = cdispos.replace(/attachment;filename=|"/gi, ''),
                                blob = new Blob([res['_body']], {
                                    type: ctype
                                }),
                                link = document.createElement('a');

                            link.href = window.URL.createObjectURL(blob);
                            link.download = filename;
                            link.click();
                        }
                    });
            });
    }

    onClickExcelBtn() {
        let that = this;
        setTimeout(function () {
            that.filterPanel.close();
        }, 10);

        this.getFollowUpListForExcel();
    }

    openFollowUpCalendarModal(): void {
        let branch_ids = "";
        if (!_.isEmpty(this.filterData["branches"])) {
            branch_ids = _.join(this.filterData["branches"], ',');
        }

        const tabParams = this['params']['tabParams'] || 'Unsold';
        const empId = this.filterData['employee_id'] || '';

        this.bsModalRef = this.modalService.show(FollowUpCalendarModalComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg compWidth-80'
        });

        this.bsModalRef.content.initModal(tabParams, branch_ids, empId, this.filterData);

        this.bsModalRef.content.applyEntriesEvent.subscribe((selectedRows: any[]) => {
            if (selectedRows && selectedRows.length > 0) {
                this.appliedFutureStIds = [];
                selectedRows.forEach(r => {
                    const sid = (r.st_id || '').toString();
                    if (sid && this.appliedFutureStIds.indexOf(sid) === -1) {
                        this.appliedFutureStIds.push(sid);
                    }
                });
                this.page.offset = 0;
                this.getFollowUpList();
            }
        });
    }

    clearAppliedFutureEntries(): void {
        this.appliedFutureStIds = [];
        this.page.offset = 0;
        this.getFollowUpList();
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/followUp/followUp.component.ts